import { STUBBED_INVITE_USER_CONNECTIONS } from '../stubbedData';

export const initialInviteUserConnectionsState = {
  userConnections: STUBBED_INVITE_USER_CONNECTIONS
};

export default function inviteUserConnections(state = initialInviteUserConnectionsState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
